import AsyncStorage from '@react-native-async-storage/async-storage';
import * as React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { Button } from 'react-native-paper';
import { NavigationRoute, NavigationScreenProp } from 'react-navigation';
import { useQuery } from 'react-query';
import { QueryContext } from '../components/QueryProvider';
import { AttendanceStatus, getAttendanceStatus, getUser, UserModel } from '../services/ApiService';

export interface IHomeScreenProps {
    navigation: NavigationScreenProp<NavigationRoute>;
}

export function HomeScreen({ navigation }: IHomeScreenProps) {
    const query = React.useContext(QueryContext);
    const { data: userData } = useQuery<UserModel>('user', async () => {
        const token = await AsyncStorage.getItem('token');
        return getUser(token?.toString() ?? '');
    });
    const { data: checkinStatus, isLoading } = useQuery<AttendanceStatus>('attendance_status', async () => {
        const token = await AsyncStorage.getItem('token');
        return getAttendanceStatus(token?.toString() ?? '');
    });

    function handleCheckin() {
        navigation.navigate('Camera', { checkout: false });
    }

    function handleCheckout() {
        navigation.navigate('Camera', { checkout: true });
    }

    // refresh each second
    React.useEffect(() => {
        const interval = setInterval(() => {
            query.invalidateQueries('attendance_status');
        }, 10000);

        console.log(checkinStatus);

        return () => clearInterval(interval);
    }, []);

    return (
        <View style={styles.container}>
            <Text style={styles.text}>Halo {userData?.name}</Text>

            {checkinStatus?.status == 'done' ? (
                <>
                    {/* right and left image from checkinStatus.photo_in and photo_out */}
                    <View style={{ flexDirection: 'row' }}>
                        <Image source={{ uri: checkinStatus.photo_in }} style={{ width: 200, height: 200, marginBottom: 10 }} />
                        <Image source={{ uri: checkinStatus.photo_out }} style={{ width: 200, height: 200, marginBottom: 10 }} />
                    </View>
                </>
            ) : (
                <>
                    <Text style={styles.textCheckin}>{checkinStatus && checkinStatus.message}</Text>
                    <Button
                        mode='contained'
                        onPress={handleCheckin}
                        style={styles.button}
                        disabled={isLoading || !checkinStatus?.checkin}
                    >Checkin</Button>
                    <Button
                        mode='contained'
                        onPress={handleCheckout}
                        style={styles.button}
                        disabled={isLoading || !checkinStatus?.checkout}
                    >Checkout</Button>
                </>

            )}

            <Text>{checkinStatus && checkinStatus.status == 'done' && 'Terimakasih banyak atas partisipasinya'}</Text>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        minWidth: 200,
        marginBottom: 10,
    },
    text: {
        fontSize: 20,
        fontWeight: 'bold',
        paddingBottom: 10,
    },
    textCheckin: {
        fontSize: 18,
        fontWeight: 'bold',
        paddingBottom: 10,
        color: 'green',
    },
});
